import React from 'react'
import PropTypes from 'prop-types'
// import Helmet from 'react-helmet'
// import { graphql, Link } from 'gatsby'
import { graphql } from 'gatsby'
import Layout from '../theme/Layout'
import SEO from "../components/SEO"
import BlogPostTemplate from './elements/BlogPostTemplate'

function BlogPost({ location, data }) {
  const { wpPost: post } = data

  return (
    <Layout location={location}>
      <BlogPostTemplate
        content={post.content}
        // categories={post.categories}
        tags={post.tags}
        title={post.title}
      // date={post.date}
      />
    </Layout>
  )
}

export function Head( { data } ) {
  const { wpPost: post } = data
  const ogimage = post?.featuredImage?.node?.sourceUrl

  return <SEO
            title={(!post.seo) ? post.title : post.seo.title}
            description={(!post.seo) ? post.except : post.seo.metaDesc}
            image={ogimage}
            noIndex={(!post.seo) ? 'index' : post.seo.metaRobotsNoindex}
            schema={(!post.seo) ? '' : post.seo.schema.raw}
            canonical={(!post.seo) ? '' : post.seo.canonical}
          />
}

BlogPost.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
    tags: PropTypes.shape({
      node: PropTypes.node
    }),
    featuedImage: PropTypes.node,
    seo: PropTypes.objectOf(
      PropTypes.string
    )
  }).isRequired,
  location: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]).isRequired
}

export default BlogPost

export const pageQuery = graphql`
  fragment PostFields on WpPost {
    id
    slug
    content
    date(formatString: "MMMM DD, YYYY")
    title
  }

  query BlogPostByID($id: String!) {
    site {
      siteMetadata {
        title
        siteUrl
      }
    }
    wpPost(id: { eq: $id }) {
      id
      title
      slug
      excerpt
      content
      date(formatString: "MMMM DD, YYYY")
      categories {
        nodes {
          name
          slug
        }
      }
      tags {
        nodes {
          name
          slug
          uri
        }
      }
      featuredImage {
        node {
          sourceUrl
        }
      }
      seo {
        title
        metaDesc
        metaRobotsNoindex
        canonical
        schema {
          raw
        }
      }
    }
  }
`
